<title mat-dialog-title>{{ 'map.shareImageDialog.title' | t }}</title>
<mat-dialog-content>
  <sn-image-editor [url]="data.url" (editedCanvas)="cropped($event)"></sn-image-editor>
</mat-dialog-content>
<mat-dialog-actions snButtonGroup>
  <button mat-button color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button mat-button *ngIf="croppedImg" (click)="download()" color="success">{{ 'common.download' | t }}</button>
  <button mat-button *ngIf="croppedImg && !hideSnapAi" (click)="snapAi()" color="success">{{ 'common.snapAi' | t }}</button>
  <button
    mat-button
    *ngIf="croppedImg && !isAdding && canClip"
    (click)="sendToVault(url)"
    color="success"
  >
    {{ 'common.addToVault' | t }}
  </button>
  <ng-container *ngIf="isAdding">{{ 'map.downloadVideo.sendingToVault' | t }}...</ng-container>
  <button mat-button *ngIf="croppedImg && !isSending" (click)="shareToChat()" color="success">
    {{ 'common.share' | t }}
  </button>
  <ng-container *ngIf="isSending">{{ 'map.downloadVideo.sendingToChat' | t }}...</ng-container>
</mat-dialog-actions>
